'use client';

import React from 'react';
import ReactMarkdown from 'react-markdown';
import Link from 'next/link';
import styles from './NewsArticle.module.scss';

interface RelatedLink {
  title: string;
  href: string;
}

interface NewsArticleProps {
  content: string;
  relatedLinks?: RelatedLink[];
}

export function NewsArticle({
  content,
  relatedLinks = []
}: NewsArticleProps) {
  return (
    <article className={styles.article}>
      <div className={styles.content}>
        <ReactMarkdown
          components={{
            h1: ({ children }) => <h2 className={styles.heading2}>{children}</h2>,
            h2: ({ children }) => <h3 className={styles.heading3}>{children}</h3>,
            h3: ({ children }) => <h4 className={styles.heading4}>{children}</h4>,
            p: ({ children }) => <p className={styles.paragraph}>{children}</p>,
            ul: ({ children }) => <ul className={styles.list}>{children}</ul>,
            ol: ({ children }) => <ol className={styles.orderedList}>{children}</ol>,
            li: ({ children }) => <li className={styles.listItem}>{children}</li>,
            strong: ({ children }) => <strong className={styles.strong}>{children}</strong>,
            a: ({ href, children }) => {
              const isInternal = href && (href.startsWith('/') || href.startsWith('#'));
              if (isInternal && href) {
                return <Link href={href} className={styles.link}>{children}</Link>;
              }
              return (
                <a href={href} className={styles.link} target="_blank" rel="noopener noreferrer">
                  {children}
                </a>
              );
            },
          }}
        >
          {content}
        </ReactMarkdown>
      </div>

      {relatedLinks.length > 0 && (
        <footer className={styles.footer}>
          <h3 className={styles.relatedTitle}>関連リンク</h3>
          <ul className={styles.relatedLinks}>
            {relatedLinks.map((link) => (
              <li key={link.href}>
                <Link href={link.href} className={styles.relatedLink}>
                  {link.title} →
                </Link>
              </li>
            ))}
          </ul>
        </footer>
      )}
    </article>
  );
}